module.exports = __webpack_public_path__ + "img/store.a3157ca7.svg";